var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97535 7.98935L19.183 7.98935L15.4025 11.4998C14.8811 11.984 14.8811 12.7103 15.4025 13.1945C15.924 13.6787 16.7061 13.6787 17.2276 13.1945L23.2242 7.6262C23.7456 7.14201 23.7456 6.41571 23.2242 5.93152L17.2276 0.36325C16.7061 -0.120947 15.924 -0.120947 15.4025 0.36325C14.8811 0.847447 14.8811 1.57374 15.4025 2.05794L19.183 5.56837L1.97535 5.56837C1.32355 5.56837 0.671744 6.05256 0.671744 6.77886C0.671744 7.50515 1.32355 7.98935 1.97535 7.98935Z",
    fill: "#474A54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9435,
    height: 13.5575,
    fill: "white",
    transform: "translate(23.6152 13.5576) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRightIcon);
export default __webpack_public_path__ + "static/media/black-right-icon.f81ae98116655b00bdb471e941b326d5.svg";
export { ForwardRef as ReactComponent };